import React from "react";
import { Button, Tooltip } from "@mantine/core";

import { DeselectIcon } from "@piqnt/runtime-core/react/Icon";

import {
  useMiddleware,
  EmitFunction,
} from "@piqnt/runtime-core/react/ReactMount";
import { SpaceContext } from "../space";

interface EditControlComponentProps {
  emit: EmitFunction;
  enable: boolean;
}

const SelectControlComponent = React.memo(
  (props: EditControlComponentProps) => {
    const { emit, enable } = props;

    const onDeselectAll = React.useCallback(() => {
      emit("deselect-all");
    }, [emit]);

    return (
      <>
        <Tooltip label="Deselect" position="bottom-start">
          <Button
            onClick={onDeselectAll}
            title="Deselect"
            variant="toolbar"
            disabled={!enable}
          >
            <DeselectIcon />
          </Button>
        </Tooltip>
      </>
    );
  },
);

export const SelectControl = () => {
  const { context, emit } = useMiddleware<SpaceContext>();
  const enable =
    context.multiselect?.value.selected.length && context.editable.value;

  return <SelectControlComponent emit={emit} enable={enable} />;
};
